'use client';

import { HeartIcon } from '@heroicons/react/24/solid';
import { useTranslations } from 'next-intl';

import { Button, HeroIcon } from '@/components/atoms';
import { Sheet, NavbarLinks, LinkButton } from '@/components/molecules';
import { LanguageSelector } from '@/components/organisms';

import type { Language, Page } from '@/lib/api/types';

export interface DrawerProps {
  pages: Page[];
  languages: Language[];
  drawerOpen: boolean;
  drawerOpenAction: (open: boolean) => void;
  menuOpen: boolean;
  menuToggle: () => void;
  authenticated: boolean;
  logoutAction?: () => void;
  loginAction?: () => void;
}

export const MobileDrawer = ({
  pages,
  languages,
  drawerOpen,
  drawerOpenAction,
  menuOpen,
  menuToggle,
  authenticated,
  logoutAction,
  loginAction,
}: DrawerProps) => {
  const t = useTranslations();
  const handleLogin = () => {
    drawerOpenAction(false);
    loginAction?.();
  };
  return (
    <Sheet.Root
      isOpen={drawerOpen}
      onOpenChange={drawerOpenAction}
      side="right"
      aria-labelledby="test"
      className="h-full flex flex-col"
    >
      <Sheet.Header>
        <Sheet.Title>{t('MENU')}</Sheet.Title>
        <Sheet.Description className="sr-only">
          {t('MOBILE_NAV_MENU')}
        </Sheet.Description>
        <Sheet.Close />
      </Sheet.Header>
      <Sheet.Body className="flex-1 overflow-auto">
        <NavbarLinks
          pages={pages}
          contextualAction={() => drawerOpenAction(false)}
        />
        {authenticated && (
          <LinkButton
            href={'/library'}
            size="sm"
            onClick={() => drawerOpenAction(false)}
          >
            <HeroIcon icon={HeartIcon} size="small" />
            {t('NAVBAR_LIBRARY')}
          </LinkButton>
        )}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center mt-4">
          {authenticated ? (
            <Button size="sm" onClick={logoutAction}>
              {t('NAVBAR_LOGOUT')}
            </Button>
          ) : (
            <Button size="sm" onClick={handleLogin}>
              {t('B2B_SIGN_IN_CTA')}
            </Button>
          )}

          <LanguageSelector
            openMenu={menuOpen}
            action={menuToggle}
            languages={languages}
            placement="start"
          />
        </div>
      </Sheet.Body>
    </Sheet.Root>
  );
};
